import { render, staticRenderFns } from "./PayBill.vue?vue&type=template&id=3806e581"
import script from "./PayBill.vue?vue&type=script&lang=ts"
export * from "./PayBill.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports